/**
 * Created by reco on 2019/10/28.
 */


	function getElement(id){
		return document.getElementById(id);
	}

	function checkIsPhone(){
		return typeof document.body.ontouchstart != 'undefined';
	}
	function bindClick(dom,callback){
		if(checkIsPhone()) {
			dom.ontouchend = callback;
		} else {
			dom.onclick = callback;
		}
	}

	/**
	 *
	 * @param config
	 *
	 * {
	 *     'token':'必填，通过结果获取',
	 *     'yuanType':'popup',可选值 ['popup','input','block']   ,
	 *     'handler':如果选了input,需要设置,
	 *     'container':如果选了block 需要这是
	 * }
	 *
	 * @constructor
	 */

	export default function CloudYuan(config){

		this.defaultConfig = {
			'yuanType':'popup',
			"container":null,
			"token":"",
			"completed":function(anwser){
				console.log("校验完成"+anwser);
			},
			"handler":null,
			"baseUrl":"https://yuan.shuidi.cn",
			"author":"水滴信用"
		};
		for(var key in config) {
			this.defaultConfig[key] = config[key];
		}
		console.log(this.defaultConfig);
		if(!this.defaultConfig['token']){
			throw 'token 不能为空';
		}

		console.log(this.defaultConfig);

		this.container =  null;
		this.img = null;
		this.slide = null;
		this.slideTrack = null;
		this.angle = 0;

		this.init();
	}

	CloudYuan.prototype = {
		init:function(){

			this.ui();
			this.event();

		},
		loadImg:function(){

			this.freshStartLoading();
			this.text.innerHTML = "加载中...";
			this.img.style.display = "none";
			this.img.src = this.defaultConfig['baseUrl']+"/cloud-yuan?token="+this.defaultConfig['token']+"&t="+new Date().getTime();

			//初始化
			this.img.style.transform = "";
			this.img.style['msTransform'] = "";

		},
		/**
		 * 创建一个状态条
		 */
		createHandler:function(){
			this.input = document.createElement('div');


			this.input.style.display="inline-block";
			this.input.style.height="42px";
			this.input.style.width="100%";
			this.input.style.border="1px solid #ccc";
			this.input.style.backgroundImage="linear-gradient(180deg, #ffffff 0%,#f3f3f3 100%)";
			this.input.style.lineHeight="42px";
			this.input.style.color="black";

			this.robotImage = new Image();
			this.robotImage.src = "https://staticcdn.shuidi.cn/yuan/shierd.png";

			this.robotImage.style.marginTop = "6px";
			this.robotImage.style.marginLeft = "6px";
			this.robotImage.style.float = "left";
			this.robotImage.style.width = "28px";
			this.robotImage.style.height = "30px";

			this.input.appendChild(this.robotImage);

			this.hanldeText = document.createElement('div');
			this.hanldeText.innerHTML = "点我验证身份";

			this.hanldeText.style.marginLeft = "6px";
			this.hanldeText.style.float = "left";

			this.input.appendChild(this.hanldeText);

			this.defaultConfig['handler'].appendChild(this.input);
			var firstClick = true;

			bindClick(this.input, function(){
				this.showCode();
				if(!firstClick){
					console.log('fresh fresh');
					this.fresh();
				}
				firstClick = false;
			}.bind(this));




			//preload two image
			new Image().src = "https://staticcdn.shuidi.cn/yuan/shierd-green.png";

		},
		handlerNormal:function(){
			this.hanldeText.innerHTML = "点我验证身份";
			this.robotImage.src = "https://staticcdn.shuidi.cn/yuan/shierd.png";
			this.hanldeText.style.color = "black";
			this.input.style.border = "1px solid #ccc"

		},
		handlerPass:function(){
			this.hanldeText.innerHTML = "校验通过";
			this.robotImage.src = "https://staticcdn.shuidi.cn/yuan/shierd-green.png";
			this.hanldeText.style.color = "green";
			this.input.style.border = "1px solid green"

		},
		showCode:function(){
			this.container.style.display = "block";

			var winSize = this.getWindowSize();
			var clientHeight = winSize[1];
			var top = (clientHeight-296-100)/2;
			var y = window.pageYOffset || window.scrollY;
			this.container.style.top = (y+top) + 'px';
			this.mask.style.top = y + "px";
			document.body.style.overflow = "hidden";
			this.mask.style.display = "block";
		},
		hideCode:function(){
			this.container.style.display = "none";
			this.mask.style.display = "none";
			document.body.style.overflow = "";
		},
		ui:function(){

			if(this.defaultConfig['yuanType']=='input') {
				this.createHandler();
			}


			this.container = document.createElement('div');


			this.imgContainer = document.createElement('div');
			this.imgContainer.style.margin="0 auto";
			this.imgContainer.style.marginTop="4px";
			this.imgContainer.style.height = "192px";
			this.imgContainer.style.width = "192px";
			this.imgContainer.style.position = "relative";
			this.imgContainer.style.lineHeight = "192px";
			this.imgContainer.style.textAlign = "center";
			this.imgContainer.style.fontSize = "16px";

			this.text = document.createElement('span');

			this.imgContainer.appendChild(this.text);
			this.container.appendChild(this.imgContainer);


			var img = new Image();
			img.onload = function(){
				this.freshEndLoading();
				this.img.style.display = "block";
			}.bind(this);
			this.img = img;


			img.style.borderRadius="96px";//更加润滑一些
			img.style.height = "192px";
			img.style.width = "192px";
			img.style.position = "absolute";
			img.style.left = 0;
			img.style.top = 0;

			this.imgContainer.appendChild(this.img);




			this.slide = document.createElement('div');

			this.slide.style.width="50px";
			this.slide.style.height="50px";
			this.slide.style.backgroundImage="url(https://staticcdn.shuidi.cn/yuan/slide.png?v=2)";
			this.slide.style.backgroundSize="contain";
			this.slide.style.left=0;
			this.slide.style.top="-10px";
			this.slide.style.position="absolute";



			this.slideTrack = document.createElement('div');
			this.slideTrack.style.height = "30px";
			this.slideTrack.style.width = "200px";
			this.slideTrack.style.backgroundColor = "#dbdcdd";
			this.slideTrack.style.position = "relative";
			this.slideTrack.style.fontSize="12px";
			this.slideTrack.style.margin = "0 auto";
			this.slideTrack.style.marginTop = "10px";
			this.slideTrack.style.lineHeight = "30px";
			this.slideTrack.style.textIndent = "60px";
			this.slideTrack.style.borderRadius="20px";
			this.slideTrack.innerHTML = "拖动滑块将图片摆正";



			var winSize = this.getWindowSize();
			var clientWidth = winSize[0];
			var clientHeight = winSize[1];
			var left = (clientWidth-252)/2;
			var top = (clientHeight-296)/2;

			if(this.defaultConfig['yuanType']=='block') {
				this.container.style.position="relative";
			}  else if(this.defaultConfig['yuanType']=='popup'){
				this.container.style.position="absolute";

				this.container.style.left = left+"px";
				this.container.style.top = top+"px";
				this.container.style.zIndex = "200000";
				this.container.style.display = "none";
			} else if(this.defaultConfig['yuanType']=='input'){
				this.container.style.position="absolute";
				this.container.style.left = left+"px";
				this.container.style.top = top+"px";
				this.container.style.display = "none";
				this.container.style.zIndex = "200000";
			}

			this.container.style.width = "250px";
			this.container.style.height = "294px";
			this.container.style.backgroundColor="#ffffff";
			this.container.style.border = "1px solid #cccccc";


			this.container.appendChild(this.slideTrack);
			this.slideTrack.appendChild(this.slide);

			this.bottomBlock = document.createElement('div');
			this.bottomBlock.style.height = "35px";
			this.bottomBlock.style.marginTop = "20px";
			this.bottomBlock.style.borderTop = "1px solid #eeeeee";
			this.bottomBlock.style.lineHeight="35px";
			this.freshBtn = document.createElement('div');
			this.freshBtn.innerHTML = "";
			this.freshBtn.style.width="15px";
			this.freshBtn.style.height="15px";
			this.freshBtn.style.backgroundImage="url(https://staticcdn.shuidi.cn/yuan/fresh.png?v=3)";
			this.freshBtn.style.backgroundSize="contain";
			this.freshBtn.style.marginTop = "10px";
			this.freshBtn.style.marginLeft = "10px";
			this.freshBtn.style.float = "left";
			this.bottomBlock.appendChild(this.freshBtn);

			this.replyBtn = document.createElement('div');
			this.replyBtn.innerHTML = "";
			this.replyBtn.style.width="15px";
			this.replyBtn.styleheight="15px";
			this.replyBtn.stylebackgroundImage="url(https://staticcdn.shuidi.cn/yuan/reply.png?v=2)";
			this.replyBtn.stylebackgroundSize="contain";
			this.replyBtn.stylemarginTop = "10px";
			this.replyBtn.stylemarginLeft = "10px";
			this.replyBtn.stylefloat = "left";

			this.bottomBlock.appendChild(this.replyBtn);


			this.closeBtn = document.createElement('div');
			this.closeBtn.innerHTML = "";
			this.closeBtn.style.width="15px";
			this.closeBtn.style.height="15px";
			this.closeBtn.style.backgroundImage="url(https://staticcdn.shuidi.cn/yuan/close.png?v=2)";
			this.closeBtn.style.backgroundSize="contain";
			this.closeBtn.style.marginTop = "10px";
			this.closeBtn.style.marginLeft = "10px";
			this.closeBtn.style.float = "left";
			this.closeBtn.style.visibility = "hidden";

			if(this.defaultConfig['yuanType']=='input' || this.defaultConfig['yuanType']=='popup' ) {
				this.closeBtn.style.visibility = "visible";
			}


			this.bottomBlock.appendChild(this.closeBtn);




			this.copyRight = document.createElement('div');
			this.copyRight.innerHTML = this.defaultConfig.author;
			this.copyRight.style.width = "168px";
			this.copyRight.style.float = "left";
			this.copyRight.style.fontSize = "12px";
			this.copyRight.style.textAlign = "right";
			this.copyRight.style.color = "#cccccc";

			this.bottomBlock.appendChild(this.copyRight);






			this.container.appendChild(this.bottomBlock);

			if (this.defaultConfig['yuanType'] == 'block') {
				this.defaultConfig['container'].appendChild(this.container);
			} else if(this.defaultConfig['yuanType'] == 'input' || this.defaultConfig['yuanType'] == 'popup') {


				this.mask = document.createElement('div');
				this.mask.style.width = clientWidth+"px";
				this.mask.style.height = clientHeight+"px";
				this.mask.style.display = "none";
				this.mask.style.backgroundColor = "black";
				this.mask.style.opacity = "0.6";
				this.mask.style.position = "absolute";
				this.mask.style.zIndex = "199999";
				this.mask.style.left = 0;
				this.mask.style.top = 0;

				document.body.appendChild(this.mask);
				document.body.appendChild(this.container);
			}
			this.loadImg();
		},
		_mouseDown:false,
		_mouseDownPos:null,
		_slidePos:0,
		event:function() {


			this.slide.ontouchstart = this.slide.onmousedown = function(e){
				console.log("drag start",e);
				this._mouseDown = true;
				this._mouseDownPos = {
					x: e.clientX || e.changedTouches[0].clientX,
					y: e.clientY || e.changedTouches[0].clientY
				};
				this._slidePos = parseInt(this.slide.style.left);
				e.preventDefault();
			}.bind(this);


			var moveCallback = function(e){
				if(this._mouseDown) {
					var x = (e.clientX || e.changedTouches[0].clientX) - this._mouseDownPos['x'];

					var realLeft = this._slidePos+x;

					if(realLeft+50 > 200){
						realLeft = 150;
					}
					if(realLeft<0) {
						realLeft = 0;
					}

					if(realLeft>=0 && realLeft+50<=200) {
						this.slide.style.left = realLeft + "px";
						var angle = parseInt(360 * realLeft/(200-50));
						this.angle = angle;
						this.img.style.transform = "rotate("+angle+"deg)";
						//兼容ie9
						this.img.style['msTransform'] = "rotate("+angle+"deg)";
					}
					e.preventDefault();
				}

			}.bind(this);


			var mouseUpCallback = function(e){
				if(this._mouseDown) {
					console.log("drag end");
					this.completed();
					this._mouseDown = false;
					e.preventDefault();
				}

			}.bind(this);

			document.body.addEventListener("mousemove",moveCallback,false);
			document.body.addEventListener("touchmove",moveCallback,false);


			document.body.addEventListener("mouseup",mouseUpCallback,false);
			document.body.addEventListener("touchend",mouseUpCallback,false);


			bindClick(this.freshBtn,this.fresh.bind(this));
			bindClick(this.replyBtn,function(){
				if(confirm('是否上报图片无法辨别方向?')){
					this.getData({
						"action":"report",
						"type":this.defaultConfig['type'],
						"angle":this.getCode()
					},function(right) {

					});
				}
			}.bind(this));
			bindClick(this.closeBtn,function(){
				this.hideCode();
			}.bind(this));

			bindClick(this.img,function () {
				this.fresh();
			}.bind(this));

		},
		fresh:function(){

			if(this.defaultConfig['yuanType']=='input') {
				this.handlerNormal();
			}

			this._mouseDown = false;
			this.angle = 0;
			this.slide.style.left = 0;
			this.img.style.transform = "";
			this.loadImg();


		},
		getCode:function(){
			return this.angle;
		},
		_callBackIndex : 0,
		getData:function(params,callback) {
			var index = this._callBackIndex ++;
			var name = "callback_"+index;
			window[name] = callback;

			params['token'] = this.defaultConfig['token'];
			params['callback'] = name;

			var queryList = [];
			for(var key in params) {
				queryList.push(key+'='+encodeURIComponent(params[key]));
			}
			var query = queryList.join('&');

			var s = document.createElement('script');
			s.src = this.defaultConfig['baseUrl']+"/cloud-yuan?"+query;
			document.body.appendChild(s);
		},
		completed:function(){
			this.img.style.display = "none";
			this.text.innerHTML = "校验中...";
			this.freshStartLoading();
			this.getData({
				"action":"check_right",
				"token":this.defaultConfig['token'],
				"angle":this.getCode()
			},function(right) {
				this.freshEndLoading();
				if(right) {
					this.text.innerHTML = "校验成功";
					if(this.defaultConfig['yuanType']=='input') {
						this.handlerPass();
						this.hideCode();
					}

					this.defaultConfig['completed'](this.angle);

				} else {
					this.text.innerHTML = "校验失败,请刷新重试";
					var freshA = document.createElement('a');
					freshA.href = "javascript:;";
					freshA.innerHTML = "刷新";
					freshA.style = "color:green;text-decoration: underline;";

					bindClick(freshA,this.fresh.bind(this));
					this.text.appendChild(freshA);



				}
			}.bind(this));

		},
		_freshAnimateWillEnd:false,
		freshStartLoading:function(animateStopCallback) {
			if(!window.requestAnimationFrame) {
				return;
			}
			this._freshAnimateWillEnd = false;
			var angle = 0;
			var step = 6;
			var rote = function(){
				angle += step;
				this.freshBtn.style.transform = "rotate("+angle+"deg)";
				if(angle==180) {
					angle = 0;
					if(this._freshAnimateWillEnd) {
						if(animateStopCallback) {
							animateStopCallback();
						}
						return;
					}
				}
				requestAnimationFrame(rote);
			}.bind(this);
			rote();
		},
		freshEndLoading:function(){
			this._freshAnimateWillEnd = true;
		},
		oncompleted:function(callback){
			this.defaultConfig['completed'] = callback;
		},
		getWindowSize:function () {
			let width = 0;
			if (window.innerWidth) {
				width = window.innerWidth;
			} else if ((document.body) && (document.body.clientWidth)) {
				width = document.body.clientWidth;
			}
			let height = 0;
			if (window.innerHeight) {
				height = window.innerHeight;
			} else if ((document.body) && (document.body.clientHeight)) {
				height = document.body.clientHeight;
			}
			return [width, height];
		}
	};

	window.CloudYuan = CloudYuan;